import React from "react";
import { GH_COLORS } from "./Style";

interface RoundBoxInputProps {
  label: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  disabled?: boolean;
  placeholder?: string;
}

function RoundBoxInput({
  label,
  value,
  onChange,
  type = "text",
  disabled = false,
  placeholder = "",
}: RoundBoxInputProps) {
  return (
    <label
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <span style={{ fontSize: 14, fontWeight: 600, color: GH_COLORS.fgDefault }}>{label}</span>
      <input
        type={type}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        style={{
          width: "100%",
          boxSizing: "border-box",
          borderRadius: 6,
          border: `1px solid ${GH_COLORS.border}`,
          padding: "8px 10px",
          fontSize: "14px",
          textAlign: "left",
          background: "#fff",
          color: GH_COLORS.fgDefault,
        }}
      />
    </label>
  );
}

export default RoundBoxInput;
